(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9272],{

/***/ 12253:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine",
      function () {
        return __webpack_require__(31671);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ magazine; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./components/withRouterPageLayout.js
var withRouterPageLayout = __webpack_require__(61167);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./store/user/actions.js
var actions = __webpack_require__(49865);
// EXTERNAL MODULE: ./store/stores/actions.js
var stores_actions = __webpack_require__(76208);
// EXTERNAL MODULE: ./store/support/actions.js
var support_actions = __webpack_require__(3697);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./containers/Support/Layout.js + 1 modules
var Layout = __webpack_require__(72998);
// EXTERNAL MODULE: ./components/Stores/StoresLayout.js + 1 modules
var StoresLayout = __webpack_require__(37497);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Stores/StoresRegionSelect.js + 1 modules
var StoresRegionSelect = __webpack_require__(58593);
// EXTERNAL MODULE: ./components/Stores/StoreCards.js
var StoreCards = __webpack_require__(53847);
;// CONCATENATED MODULE: ./containers/Stores/index.js





var StoresContainer = function(param) {
    var stores = param.stores, regions = param.regions, currentRegion = param.currentRegion;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresRegionSelect/* default */.Z, {
                regions: regions,
                currentRegion: currentRegion
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCards/* default */.Z, {
                stores: stores
            })
        ]
    });
};
StoresContainer.propTypes = {
    stores: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        address: (prop_types_default()).string,
        first_name: (prop_types_default()).string,
        last_name: (prop_types_default()).string,
        phoneNumber: (prop_types_default()).string,
        schedule: (prop_types_default()).array
    })),
    regions: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: (prop_types_default()).string.isRequired
    }))
};
/* harmony default export */ var Stores = (StoresContainer);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
;// CONCATENATED MODULE: ./pages/magazine/index.js
















function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var StoresPage = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(StoresPage, Component1);
    var _super = _createSuper(StoresPage);
    function StoresPage() {
        _classCallCheck(this, StoresPage);
        return _super.apply(this, arguments);
    }
    _createClass(StoresPage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, stores = _props.stores, regions = _props.regions, supportCategories = _props.supportCategories;
                // Check store data
                if (!stores || !regions) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                        children: "Nu au fost gasite magazine"
                    }));
                }
                // Get stores in the network
                var storesList = stores.filter(function(store) {
                    return store.network === settings.websiteId;
                });
                var regionsList = (0,helpers/* getRegionsWithStores */.Ly)({
                    regions: regions,
                    stores: storesList
                });
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Lant de magazine"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            className: "pt-3",
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 2,
                                    name: "Suport clienti",
                                    url_key: "suport-clienti/"
                                },
                                {
                                    id: 2,
                                    level: 99,
                                    name: "Magazine"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                            categories: supportCategories,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresLayout/* default */.Z, {
                                title: "Magazine",
                                regions: regionsList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stores, {
                                    stores: storesList,
                                    regions: regionsList
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return StoresPage;
}(react.Component);
StoresPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var reduxStore, query, categories, regions, stores, promises;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore, query = ctx.query;
                    categories = reduxStore.getState().support.categories;
                    regions = reduxStore.getState().user.regions;
                    stores = reduxStore.getState().stores;
                    promises = [];
                    // Load data
                    !categories && promises.push(reduxStore.dispatch((0,support_actions/* getSupportCategories */.eU)()));
                    !regions && promises.push(reduxStore.dispatch((0,actions/* getRegions */.JL)()));
                    !stores.data && promises.push(reduxStore.dispatch((0,stores_actions/* getStores */.r8)()));
                    _ctx.next = 10;
                    return Promise.all(promises);
                case 10:
                    return _ctx.abrupt("return", {
                        query: query
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
StoresPage.pageLayout = "default";
StoresPage.layoutProps = {
    displaySearch: false
};
/* harmony default export */ var magazine = ((0,withRouterPageLayout/* default */.Z)((0,es/* connect */.$j)(function(state) {
    return {
        stores: state.stores.data,
        regions: state.user.regions,
        supportCategories: state.support.categories
    };
})(StoresPage)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8208,5337,3043,5202,4341,1223,7840,9774,2888,179], function() { return __webpack_exec__(12253); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);